import { render, staticRenderFns } from "./dkmxList.vue?vue&type=template&id=5269c7de&scoped=true"
import script from "./dkmxList.vue?vue&type=script&lang=js"
export * from "./dkmxList.vue?vue&type=script&lang=js"
import style0 from "./dkmxList.vue?vue&type=style&index=0&id=5269c7de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5269c7de",
  null
  
)

export default component.exports